import {RANKING_TOOLTIPS_HIDE, RANKING_TOOLTIPS_SHOW} from "./rankingTooltipsActions";


const tooltips = {
    teams: {
        textId: 'ranking.tooltips.teams',
        className: 'ranking-tooltip--teams',
        tooltipStyle: 'zw-tooltip--top'
    },
    points: {
        textId: 'ranking.tooltips.points',
        className: 'ranking-tooltip--points',
        tooltipStyle: 'zw-tooltip--top'
    },
    tabs: {
        textId: 'ranking.tooltips.tabs',
        className: 'ranking-tooltip--tabs',
        tooltipStyle: 'zw-tooltip--switcher-tabs'
    },
    tutorial: {
        textId: 'ranking.tooltips.tutorial',
        className: 'ranking-tooltip--tutorial',
        tooltipStyle: 'zw-tooltip--top'
    }
};

export const rankingTooltipsReducer = (state = {
    show: false,
    tooltips: tooltips
}, action) => {
    switch (action.type) {
        case RANKING_TOOLTIPS_HIDE:
            return {...state, show: false};
        case RANKING_TOOLTIPS_SHOW:
            return {...state, show: true};
        default:
            return state;
    }
};